import log from 'salvo-lite/log'

class Article {
    constructor (components) {
        log.debug('Article', 'Constructing', components)
        this.components = components
    }

    onInit () {
        let temp = 'delete'
        log.debug(this._name, 'what', temp)
        this.components.getComponentsById('articleSlider').init()
    }
}

export default Article



// WEBPACK FOOTER //
// ./src/scripts/pages/Article.js